import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from '@mui/material';
import SimpleDatePicker from '../../../../ui/simpleDatePicker';

export default function CreateReturnInvoiceDialog({
    open,
    onClose,
    onSave,
    invoiceItems = [],
    loading = false,
}) {
    const [returnReason, setReturnReason] = useState('');
    const [notes, setNotes] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!open) return;

        setReturnReason('');
        setNotes('');
        setInvoiceDate('');
        setErrors({});
    }, [open]);

    const validate = () => {
        const nextErrors = {};

        if (!returnReason || returnReason.trim().length < 3) {
            nextErrors.returnReason = 'Reason is required (minimum 3 characters).';
        }

        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const payload = {
            returnReason: returnReason.trim(),
            notes: notes.trim() || null,
            invoiceDate: invoiceDate || null,
        };

        const result = await onSave(payload);
        if (result !== false) {
            onClose();
        }
    };

    const sourceItemCount = (invoiceItems || []).filter(item => !item._markedForDeletion).length;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Create Return Invoice</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <Alert severity="info">
                        A dedicated return invoice will be generated by automatically reversing the source invoice.
                        Items, payments, discounts, and insurance claims are mirrored as negative counterparts.
                    </Alert>

                    <Typography variant="body2" color="text.secondary">
                        Source invoice items detected: {sourceItemCount}
                    </Typography>

                    <TextField
                        label="Return Reason"
                        value={returnReason}
                        onChange={(e) => setReturnReason(e.target.value)}
                        error={!!errors.returnReason}
                        helperText={errors.returnReason}
                        required
                        fullWidth
                        multiline
                        rows={2}
                    />

                    <SimpleDatePicker
                        label="Return Invoice Date"
                        value={invoiceDate}
                        onChange={setInvoiceDate}
                        fullWidth
                    />

                    <TextField
                        label="Notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        multiline
                        rows={2}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={loading}>
                    Create Return Invoice
                </Button>
            </DialogActions>
        </Dialog>
    );
}
